"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }var _toolkit = require('@reduxjs/toolkit');



var _actionCreators = require('shared/actions/actionCreators'); var _actionCreators2 = _interopRequireDefault(_actionCreators);

/* Each org's templates the signed-in user can see, by name as the server
 * sorts them. A list replaces the org's entry, so templates the user can no
 * longer see (they left the team) drop out the next time it loads. */


const initialState = {}

const byName = (a, b) => {
  const [x, y] = [a.Name.toLowerCase(), b.Name.toLowerCase()]
  if (x !== y) return x < y ? -1 : 1
  return a.TemplateKey < b.TemplateKey ? -1 : a.TemplateKey > b.TemplateKey ? 1 : 0
}

const upsert = (state, template) => {
  const others = (_nullishCoalesce(state[template.OrgKey], () => ( []))).filter(t => t.TemplateKey !== template.TemplateKey)
  state[template.OrgKey] = [...others, template].sort(byName)
}

const reducer = _toolkit.createReducer.call(void 0, initialState, builder => {
  builder.addCase(_actionCreators2.default.listMessageTemplatesActions.SUCCESS, (s, a) => {
    s[a.meta.OrgKey] = a.payload.Templates
  })
  builder.addCase(_actionCreators2.default.createMessageTemplateActions.SUCCESS, (s, a) => upsert(s, a.payload))
  builder.addCase(_actionCreators2.default.updateMessageTemplateActions.SUCCESS, (s, a) => upsert(s, a.payload))
  builder.addCase(_actionCreators2.default.restoreMessageTemplateActions.SUCCESS, (s, a) => upsert(s, a.payload))
  // One template's latest version. A reply can land after a newer local
  // save or restore (it was read before them); it never rewinds the store.
  builder.addCase(_actionCreators2.default.getMessageTemplateActions.SUCCESS, (s, a) => {
    const { OrgKey, TemplateKey, KnownUpdatedAt } = a.meta
    const cached = (_nullishCoalesce(s[OrgKey], () => ( []))).find(t => t.TemplateKey === TemplateKey)
    const { Template } = a.payload
    if (Template) {
      if (cached && cached.UpdatedAt > Template.UpdatedAt) return
      return upsert(s, Template)
    }
    // Deleted: unless a newer version (a restore) arrived since the caller's.
    if (cached && KnownUpdatedAt && cached.UpdatedAt > KnownUpdatedAt) return
    s[OrgKey] = (_nullishCoalesce(s[OrgKey], () => ( []))).filter(t => t.TemplateKey !== TemplateKey)
  })
  builder.addCase(_actionCreators2.default.deleteMessageTemplateActions.SUCCESS, (s, a) => {
    const { OrgKey, TemplateKey } = a.meta
    s[OrgKey] = (_nullishCoalesce(s[OrgKey], () => ( []))).filter(t => t.TemplateKey !== TemplateKey)
  })
  builder.addCase(_actionCreators2.default.logoutAction, () => initialState)
})

exports. default = reducer
